module.exports = __webpack_public_path__ + "img/oaknest-9.653f2f45.jpeg";